// import { Theme } from '@mui/material/styles'
declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    primary_gradient: true
    secondary: true
    primary: true
    outline_edit: true
    cancel: true
    remove: true
  }
}
export const MuiButton = {
  // export default function Button(theme: Theme) {
  defaultProps: {
    variant: 'contained',
  },
  styleOverrides: {
    root: {
      backgroundColor: '#004744',
      textTransform: 'none',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '115%',
      color: '#fff',
      borderRadius: '5px',
      '&.Mui-disabled': {
        backgroundColor: '#f7f7f7',
        boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
        opacity: '0.5',
        color: '#000',
      },
      '&:hover': {
        backgroundColor: '#004744',
        color: '#fff',
      },
    },
    contained: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    sizeSmall: {
      minWidth: '70px',
      height: '26px',
      fontSize: '14px',
    },
  },
  variants: [
    {
      props: {
        variant: 'primary',
      },
      style: {
        backgroundColor: '#004744',
        textTransform: 'none',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '115%',
        color: '#FFF',
        borderRadius: '5px',
        '&.Mui-disabled': {
          backgroundColor: '#004744',
          opacity: '0.5',
          color: '#000',
        },
        '&:hover': {
          backgroundColor: '#004744',
          color: '#FFF',
        },
      },
    },
    {
      props: { variant: 'cancel' },
      style: {
        textTransform: 'none',
        backgroundColor: '#aaaaaa',
        border: `2px dashed #aaaaaa`,
        'hover:': {
          backgroundColor: '#999999',
        },
      },
    },
    {
      props: {
        variant: 'secondary',
      },
      style: {
        backgroundColor: '#e6eded',
        textTransform: 'none',
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '14px',
        color: '#004744',
        borderRadius: '5px',
        '&.Mui-disabled': {
          backgroundColor: '#004744',
          opacity: '0.5',
          color: '#000',
        },
        '&:hover': {
          backgroundColor: '#e6eded',
          color: '#004744',
        },
      },
    },
    {
      props: { variant: 'remove' },
      style: {
        textTransform: 'none',
        backgroundColor: '#EFEFEF',
        'hover:': {
          backgroundColor: '#999999',
        },
        color: '#8A8A8A',
        fontWeight: '500',
        fontSize: '12px',
        lineHeight: '14px',
      },
    },
  ],
}
